import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initCollectionSearchFilters from '../sections/collection/initCollectionSearchFilters';
import initCustomSortBy from '../sections/collection/initCustomSortBy';

ready(() => {
  initCollectionSearchFilters();
  initCustomSortBy();
});

onShopifySectionLoad(() => {
  initCollectionSearchFilters();
  initCustomSortBy();
});
